import { useState, useEffect } from "react"
import { PropTypes } from "prop-types"
import _ from "lodash"

import ReactSlider from "react-slider"
import classNames from "classnames"

import { isSingleSlider } from "./utils"

/**
 * Slider component. There are two types of slider
 * - single slider (ie durataion) -> slider library will handle it as a number
 * - double slider (ie prices) -> slider library will handle it as an array of numbers
 *
 * Moreover, if new values are same that original value, we wont dispatch onCompleteChange fuction to
 * avoid unneeded request to API
 * @param {number} limitMin min limit
 * @param {number} limitMax max limit
 * @param {array} value array with min and max values. For single slider, min value will be null
 * @param {number} step step slider
 * @param {function} onChange function dispatched when value has changed but movement has not finisthed
 * @param {array} ariaLabel list of accessibility labels (one for min thumb and another for max thumb)
 * @param {array} ariaValueText list of accessibility values (one for min value and another for max value)
 */
const Slider = ({
  limitMin,
  limitMax,
  disabled,
  onChange,
  step = 1,
  ariaValueText = [],
  ariaLabel = [],
  value = []
}) => {
  // Display single slider when minLimit is null
  const [sliderValue, setSliderValue] = useState(
    value[0] === null ? value[1] : [value[0], value[1]]
  )
  useEffect(() => {
    setSliderValue(value[0] === null ? value[1] : [value[0], value[1]])
  }, [value])

  const handleChange = updatedValue => {
    setSliderValue(updatedValue)
    if (isSingleSlider(updatedValue)) {
      onChange([null, updatedValue])
    } else {
      onChange(updatedValue)
    }
  }

  const renderAriaValueText = index => {
    return _.isNumber(sliderValue) ? ariaValueText[0] : ariaValueText[index]
  }

  return (
    <ReactSlider
      className={classNames("oj-slider", "horizontal-slider", {
        "single-slider": _.isNumber(sliderValue),
        "double-slider": !_.isNumber(sliderValue),
        "state-disabled": disabled
      })}
      thumbClassName="slider-draggable-circle"
      trackClassName="slider-back-track"
      min={limitMin}
      max={limitMax}
      ariaLabel={ariaLabel}
      ariaValuetext={state => renderAriaValueText(state.index)}
      defaultValue={sliderValue}
      step={step}
      disabled={disabled}
      minDistance={step}
      value={sliderValue}
      onChange={handleChange}
    />
  )
}

Slider.propTypes = {
  limitMin: PropTypes.number.isRequired,
  limitMax: PropTypes.number.isRequired,
  step: PropTypes.number,
  value: PropTypes.arrayOf(PropTypes.number),
  disabled: PropTypes.bool,
  ariaValueText: PropTypes.arrayOf(PropTypes.string),
  ariaLabel: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func
}

export default Slider
